/**
 *  Default validation error messages.
 */
export default  {
    default: "Errore sul campo %s",
    required: "Il campo %s è obbligatorio",
    enum: "Il campo %s deve essere uno di %s",
    whitespace: "Il campo %s non può essere vuoto",
    additional: "Sono presenti campi estranei (%s) in %s",
    date: {
        format: "Il campo %s non ha un formato valido",
        invalid: "Il campo %s non è valido"
    },
    types: {
        string: "Il campo %s non è una %s",
        null: "Il campo %s non è %s",
        function: "Il campo %s non è una %s",
        instance: "Il campo %s non è una istanza di %s",
        array: "Il campo %s non è un %s",
        object: "Il campo %s non è un %s",
        number: "Il campo %s non è un %s",
        boolean: "Il campo %s non è un %s",
        integer: "Il campo %s non è un %s",
        float: "Il campo %s non è un %s",
        regexp: "Il campo %s non è una %s valida",
        multiple: "Il campo %s non è uno dei tipi permessi %s"
    },
    function: {
        len: "Il campo %s deve avere esattamente %s argomenti",
        min: "Il campo %s deve avere almeno %s argomenti",
        max: "Il campo %s non può avere più di %s argomenti",
        range: "Il campo %s deve avere il numero di argomenti compreso fra %s e %s"
    },
    string: {
        len: "Il campo %s deve avere esattamente %s caratteri",
        min: "Il campo %s deve avere almeno %s caratteri",
        max: "Il campo %s non può avere più di %s caratteri",
        range: "Il campo %s deve avere un numero di caratteri compreso tra %s e %s"
    },
    number: {
        len: "Il campo %s deve essere uguale a %s'",
        min: "Il campo %s non può essere minore di %s",
        max: "Il campo %s non può essere maggiore di %s",
        range: "Il campo %s deve essere compreso tra %s e %s"
    },
    array: {
        len: "Il campo %s deve essere lungo esattamente %s",
        min: "Il campo %s non può essere lungo meno di %s",
        max: "Il campo %s non può essere luno più di %s",
        range: "Il campo %s deve avere lunghezza compresa fra %s e %s"
    },
    pattern: {
        mismatch: "Il campo %s non è valido"
    }
};
